import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyPageKey } from '../lib/domHooks';
import { bodyPageKey } from '../lib/pageKey';
import { useSettings } from '../context/SettingsContext';
import { adminRoutesVisible } from '../lib/adminDomain';

/**
 * `<body>` üzerine bulunulan sayfanın adını yazar.
 *
 * Panelden yazılan CSS'in "yalnızca slot sayfasında" demesinin tek yolu budur
 * (`body[data-bhs-page="slot"] …`). Nitelik `<body>`ye konur, kabuğun bir
 * düğümüne değil: kural bir tema kabuğunun içindeki bir sınıfa bağlanırsa
 * şema değiştiğinde sessizce çalışmaz olur.
 *
 * Sayfadan çıkarken nitelik **bırakılmaz**: kalırsa oyuncu başka bir sayfada
 * eski sayfanın kurallarını görürdü (spor kitabındaki `sb-chrome-hidden`
 * sınıfında ölçülen tuzağın aynısı). Uygulama kapanırken de temizlenir.
 */
const PageMarker = () => {
  const { pathname } = useLocation();
  const settings = useSettings();
  const panelRoutes = adminRoutesVisible(settings);

  useEffect(() => {
    const key = bodyPageKey(pathname);
    // Panel ayrı alan adına kilitliyken ana sitedeki /admin tanımsız bir
    // adrestir; `admin` yazmak onu diğer 404'lerden ayırıp panelin
    // varlığını duyururdu.
    applyPageKey(key === 'admin' && !panelRoutes ? 'other' : key);
    return () => applyPageKey('');
  }, [pathname, panelRoutes]);

  return null;
};

export default PageMarker;
